// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"2d67175d","759":"5cd560df","830":"ef308b7e","893":"b040345f"}[chunkId] + ".chunk.js";
};